import { Box } from "@mui/material";
import PropTypes from "prop-types";
import ICONS from "../../assets/Icons";
import { GlobalConfiguration } from "../../utils/configurationProvider";
import "../QuickActionCard/QuickActionCard.css";
import SvgComponent from "../_utils/SVGComponent";

const QuickActionCard = ({
  title,
  labels,
  onClick,
  labelDisabled = false,
  type,
}) => {
  const labelList = Array.isArray(labels) ? labels : [labels];

  return (
    <div
      className={`flex flex-col w-full Qlg:mt-margin-base Qlg:right-right-base ${type === "privateTxn" || type === "taxTxn" ? "" : "mt-margin-md"}`}
    >
      <Box
        sx={{
          width: "var(--width-full)",
          opacity: "var(--base-opacity)",
          borderRadius: "var(--border-radius-md)",
          bgcolor: "var(--primary-card)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="w-full h-full">
          <div
            className="TittleContent flex items-center gap-gap-sm"
            style={{ maxWidth: "var(--width-full)" }}
          >
            <img
              src={ICONS?.ADD}
              alt="add action"
              className="w-icon-sm h-icon-sm"
            />
            <p>{title}</p>
          </div>
          <div className="border-border border-primary-bg mx-margin-md"></div>
          <div className="p-padding-sm flex flex-col gap-gap-sm">
            {labelList.map((label, index) => (
              <div
                key={index}
                className="flex flex-col w-full"
              >
                <div
                  className={`RightContent relative z-z-index-base ${
                    labelDisabled
                      ? "cursor-not-allowed opacity-light-opacity"
                      : "cursor-pointer global-hover-white"
                  }`}
                  onClick={() => onClick?.(label)}
                >
                  <div className="leftContent">
                    <p>{label}</p>
                  </div>

                  <div className="SideContent">
                    <SvgComponent
                      url={ICONS?.ARROW_RIGHT_WHITE}
                      height="var(--icon-sm)"
                      width="var(--icon-sm)"
                      color="var(--text-primary)"
                    />
                  </div>
                </div>

                {index !==
                  labelList.length - GlobalConfiguration?.lengthCheckOne && (
                  <div className="border-b border-primary-bg mx-margin-sm mt-margin-sm"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Box>
    </div>
  );
};

QuickActionCard.propTypes = {
  title: PropTypes.string.isRequired,
  labels: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  // To add multiple labels, pass an array like this:  labels={[ " "," ", " " ]}
  onClick: PropTypes.func,
  labelDisabled: PropTypes.bool,
};

export default QuickActionCard;
